<template>
  <intersection-observer
    class="event-video-observer-container"
    :observe-from-bottom="true"
    :observe-view-height="100"
    @element-in-view="handleElementInView"
  >
    <div :class="videoAspectClass" class="eventDetail-information-iframe-container">
      <iframe
        v-if="isVisible"
        :src="videoUrl"
        class="eventDetail-information-iframe-video"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
        v-bind="isTikTok ? { scrolling: 'no' } : {}"
      ></iframe>
      <div v-else class="loading-placeholder">
        <icon :pulse="true" fas="fa-spinner" />
      </div>
    </div>
  </intersection-observer>
</template>

<script setup lang="ts">
type PlatformType = 'youtube' | 'tiktok'

const props = defineProps({
  videoUrl: { type: String, default: '', required: true },
  videoAspectRatio: { type: Object, default: () => ({ width: 16, height: 9 }), required: true },
  platformType: { type: String, default: 'youtube' as PlatformType }
})

const isVisible = ref(false)

const isTikTok = computed(() => props.platformType === 'tiktok')
const videoAspectClass = computed(() => {
  const { width, height } = props.videoAspectRatio
  if (width < height) return 'nine_sixteen'
  return 'sixteen_nine'
})

const handleElementInView = () => {
  isVisible.value = true
}
</script>

<style scoped lang="scss">
.event-video-observer-container {
  width: 100%;
  height: 100%;
}

.eventDetail-information-iframe-container {
  position: relative;
  display: block;

  &.sixteen_nine {
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  &.nine_sixteen {
    width: 240px;
    aspect-ratio: 9 / 16;
    margin: 0 auto;
  }
}

.eventDetail-information-iframe-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.loading-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
</style>
